import React, { Suspense } from "react";
import {
	BrowserRouter as Router,
	Routes,
	Route,
	Navigate,
} from "react-router-dom";
import { routesConfig } from "./routesConfig";
import LoadingSpinner from "@components/LoadingSpinner";
import Layout from "@components/Layout/Layout";
import PrivateRoute from "./PrivateRoute";
import { ROUTES } from "constants/routes";

const AppRouter: React.FC = () => {
	return (
		<Router>
			<Suspense fallback={<LoadingSpinner />}>
				<Routes>
					{routesConfig.map(
						({ path, component: Component, private: isPrivate }) => {
							const element = isPrivate ? (
								<PrivateRoute>
									<Layout>
										<Component />
									</Layout>
								</PrivateRoute>
							) : (
								<Component />
							);

							return <Route key={path} path={path} element={element} />;
						},
					)}

					{/* Catch-all route */}
					<Route path="*" element={<Navigate to={ROUTES.HOME} replace />} />
				</Routes>
			</Suspense>
		</Router>
	);
};

export default AppRouter;
